import { createAsyncThunk } from "@reduxjs/toolkit"
import { acceptEjectApi, cancelEjectApi, ejectDetailsApi, ejectHistoryApi, initiateEjectApi, rejectEjectApi, resenedEjectEmailApi } from "../apis/EjectApi"
import { checkUserExistsApi } from "../apis/AuthApi"
import { IPagination } from "../apis/AdminApis/AdminDataApi"

export const initiateEjectAction = createAsyncThunk("initiate/eject", async (data: { business_id: string, recipient_email: string }, { rejectWithValue }) => {
    try {
        const response = await initiateEjectApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not initiate eject" })
    }
})

export const ejectHistoryAction = createAsyncThunk("eject/history", async (data: IPagination, { rejectWithValue }) => {
    try {
        const response = await ejectHistoryApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get eject history" })
    }
})

export const cancelEjectAction = createAsyncThunk("cancel/eject", async (business_id: string, { rejectWithValue }) => {
    try {
        const response = await cancelEjectApi({ business_id })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not cancel eject" })
    }
})

export const resendEjectEmailAction = createAsyncThunk("resend/eject-email", async (business_id: string, { rejectWithValue }) => {
    try {
        const response = await resenedEjectEmailApi({ business_id })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not resend eject email" })
    }
})

export const acceptEjectAction = createAsyncThunk("accept/eject", async (token: string, { rejectWithValue }) => {
    try {
        const response = await acceptEjectApi({ token })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not accept eject" })
    }
})

export const rejectEjectAction = createAsyncThunk("reject/eject", async (data: { token: string, reject_reason: string }, { rejectWithValue }) => {
    try {
        const response = await rejectEjectApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not reject eject" })
    }
})

export const ejectDetailsAction = createAsyncThunk("eject/details", async (token: string, { rejectWithValue }) => {
    try {
        const response = await ejectDetailsApi({ token })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get eject details" })
    }
})

export const checkUserExistsAction = createAsyncThunk("eject/check-user", async (token: string, { rejectWithValue }) => {
    try {
        const response = await checkUserExistsApi(token)
        return response
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not check user existence" })
    }
})